import { useMutation, useQueryClient } from "react-query";

import { WorkspaceDocumentData } from "@interfaces/company/workspace";
import { workspaceQueryKeys } from "./queryKeys";
import { workspaceService } from "@services/workspace-service";

export const useCreateWorkspaceDocumentMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (data: WorkspaceDocumentData) => workspaceService.createDocument(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(workspaceQueryKeys.allDirectoriesFiles);
      },
    }
  );
};
